{
	"title": "Faktury",
	"buttonShowMoreInvoicesTitle": "Zobrazit více faktur",
	"invoicesTableHeaders": {
		"date": "Datum",
		"invoiceNumber": "Číslo faktury",
		"deliveredQuantity": "Dodané množství",
		"bundledCarbonSavings": "Souhrnné snížení uhlíku",
		"transactionId": "ID transakce"
	},
	"errorMessage": "Faktury se nepodařilo načíst"
}
